module.exports = "const { Generator } = Musika\n\nconst F = 79            // Base frequency\nconst DF = 4            // Beat frequency\nconst A = Math.SQRT1_2  // Amplitude\n\nconst oscL = Generator.Sin()\nconst oscR = Generator.Sin()\n\nreturn t => [\n  oscL(F, t) * A,\n  oscR(F + DF, t) * A,\n]\n"


//////////////////
// WEBPACK FOOTER
// ../~/raw-loader!../examples/binaural.js
// module id = 43
// module chunks = 1